import { Children, useState } from "react";

import { IMultistepRootProps } from "./types";
import { MultistepContext } from "./context";
import { Container, Button } from "./styled";

export function MultistepRoot({ onSubmit, children }: IMultistepRootProps) {
  const [currentStep, setCurrentStep] = useState(0);
  const totalSteps = Children.count(children);

  function handleNextStep() {
    if (currentStep === totalSteps - 1) return onSubmit();

    setCurrentStep(currentStep + 1);
  }

  function handlePrevStep() {
    if (currentStep === 0) return;

    setCurrentStep(currentStep - 1);
  }

  function handleMoveStep(step: number) {
    setCurrentStep(step);
  }

  function handleSave() {
    onSubmit();
  }

  return (
    <>
      <Container>
        {Children.map(children, (child, index) => (
          <Button
            key={child.props.title}
            variant={currentStep === index ? "active" : "inactive"}
            disabled={child.props.disabled}
            onClick={() => handleMoveStep(index)}
          >
            {child.props.title}
          </Button>
        ))}
      </Container>
      <MultistepContext.Provider
        value={{
          handleNextStep,
          handlePrevStep,
          handleSave,
          isFirstStep: currentStep === 0,
          isLastStep: currentStep === totalSteps - 1,
        }}
      >
        <div>{children[currentStep]}</div>
      </MultistepContext.Provider>
    </>
  );
}
